import { Injectable, inject } from '@angular/core';
import { CanMatch, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { LocalStorageAuthTokenKey } from '@midas/shared/common';
import { Store } from '@ngrx/store';
import { AuthActions } from '@midas/shared/data-access';

interface JwtPayload {
  auth_time: number;
  client_id: string;
  'cognito:groups': string[];
  event_id: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  origin_jti: string;
  scope: string;
  sub: string;
  token_use: string;
  username: string;
}

enum ICognitoGroups {
  control_zone = 'Control_Zone',
}

@Injectable({ providedIn: 'root' })
export class OverviewGroupGuard implements CanMatch {
  private readonly store = inject(Store);
  constructor(private router: Router) {}

  canMatch(): Observable<boolean | UrlTree> {
    let validation: boolean;
    const decoded = jwtDecode<JwtPayload>(LocalStorageAuthTokenKey.authToken);
    decoded && decoded['cognito:groups']
      ? decoded['cognito:groups'].find((group) => group === ICognitoGroups.control_zone)
        ? (validation = true)
        : (validation = false)
      : (validation = false);

    if (!validation) {
      this.store.dispatch(AuthActions.loginGroupAccessError());
    }
    return of(true);
  }
}
